import { FC } from 'react';
import Markdown from 'markdown-to-jsx';
import { FdOutload } from '@qodly/icons';

import cn from 'classnames';

import { IVideoTip } from '../interfaces';

const VideoTip: FC<Partial<Omit<IVideoTip, 'type'>>> = ({
  video,
  body,
  title,
  isInsideCarousel,
}) => {
  return (
    <div
      className={cn([
        {
          'flex flex-row': !isInsideCarousel,
          'flex max-h-[10rem] flex-col overflow-y-auto': isInsideCarousel,
        },
      ])}
    >
      <div
        className={cn([
          {
            'mr-1': !isInsideCarousel,
            'mb-1': isInsideCarousel,
          },
        ])}
      >
        <iframe
          height={isInsideCarousel ? 'auto' : 90}
          width={isInsideCarousel ? '100%' : 160}
          src={video?.link}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      <article
        className={cn([
          'prose prose-sm p-1 text-left text-xs text-grey-100',
          {
            'w-60 overflow-auto': !isInsideCarousel,
            '-mt-6': isInsideCarousel,
          },
        ])}
      >
        <Markdown
          children={body || ''}
          options={{
            overrides: {
              a: {
                component: ({ children, ...props }) => {
                  return (
                    <a
                      {...props}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-start"
                    >
                      {children}
                      <FdOutload className="ml-1 mt-px h-4 w-4" />
                    </a>
                  );
                },
              },
            },
          }}
        />
      </article>
    </div>
  );
};

export default VideoTip;
